import {gql} from "@irati/utils/gql"

const query = gql`
  query GlobalTenant($subdomain: String!) {
    globalTenant(subdomain: $subdomain) {
      subdomain
      tenantId
      region
    }
  }
`

export const toString = query.loc.source.body

export default query
